import _JSXStyle from "styled-jsx/style";
import { UserAvatar } from '@dhis2-ui/user-avatar';
import { useConfig } from '@dhis2/app-runtime';
import PropTypes from 'prop-types';
import React from 'react';
import { joinPath } from '../join-path.js';
import i18n from '../locales/index.js';

const ProfileName = _ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    "data-test": "headerbar-profile-username",
    className: "jsx-2223023701"
  }, children, /*#__PURE__*/React.createElement(_JSXStyle, {
    id: "2223023701"
  }, ["div.jsx-2223023701{margin-bottom:3px;font-size:16px;line-height:19px;}"]));
};

ProfileName.propTypes = {
  children: PropTypes.string
};

const ProfileEmail = _ref2 => {
  let {
    children
  } = _ref2;
  return /*#__PURE__*/React.createElement("div", {
    "data-test": "headerbar-profile-user-email",
    className: "jsx-1072768994"
  }, children, /*#__PURE__*/React.createElement(_JSXStyle, {
    id: "1072768994"
  }, ["div.jsx-1072768994{margin-bottom:6px;font-size:14px;line-height:16px;}"]));
};

ProfileEmail.propTypes = {
  children: PropTypes.string
};

const ProfileEdit = _ref3 => {
  let {
    children
  } = _ref3;
  const {
    baseUrl
  } = useConfig();
  return /*#__PURE__*/React.createElement("a", {
    href: joinPath(baseUrl, 'dhis-web-user-profile/#/profile'),
    "data-test": "headerbar-profile-edit-profile-link",
    className: "jsx-233684196"
  }, children, /*#__PURE__*/React.createElement(_JSXStyle, {
    id: "233684196"
  }, ["a.jsx-233684196{color:rgba(0,0,0,0.87);font-size:12px;line-height:14px;-webkit-text-decoration:underline;text-decoration:underline;cursor:pointer;}"]));
};

ProfileEdit.propTypes = {
  children: PropTypes.string
};

const ProfileDetails = _ref4 => {
  let {
    name,
    email
  } = _ref4;
  return /*#__PURE__*/React.createElement("div", {
    className: "jsx-4236878114"
  }, /*#__PURE__*/React.createElement(ProfileName, null, name), /*#__PURE__*/React.createElement(ProfileEmail, null, email), /*#__PURE__*/React.createElement(ProfileEdit, null, i18n.t('Edit profile')), /*#__PURE__*/React.createElement(_JSXStyle, {
    id: "4236878114"
  }, ["div.jsx-4236878114{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column;margin-inline-start:20px;color:#000;font-size:14px;font-weight:400;}"]));
};

ProfileDetails.propTypes = {
  email: PropTypes.string,
  name: PropTypes.string
};
export const ProfileHeader = _ref5 => {
  let {
    name,
    email,
    avatarId
  } = _ref5;
  return /*#__PURE__*/React.createElement("div", {
    className: "jsx-371352323"
  }, /*#__PURE__*/React.createElement(UserAvatar, {
    avatarId: avatarId,
    name: name,
    dataTest: "headerbar-profile-menu-icon",
    large: true
  }), /*#__PURE__*/React.createElement(ProfileDetails, {
    name: name,
    email: email
  }), /*#__PURE__*/React.createElement(_JSXStyle, {
    id: "371352323"
  }, ["div.jsx-371352323{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;margin-inline-start:24px;padding-top:20px;}"]));
};
ProfileHeader.propTypes = {
  avatarId: PropTypes.string,
  email: PropTypes.string,
  name: PropTypes.string
};